import React, { useMemo } from "react";
import { Link } from "react-router-dom";
import useFetchProcessed from "../../../Hooks/qlp_ddpcr/useFetchProcessed";
import { DataGrid, GridToolbar } from "@material-ui/data-grid";
import * as fileConstants from "../../../constants/fileConstants";
import Spinner from "../../../common/Spinner";
import { formatDate } from "../../../../utils/basic";


const ddPcrListProcessed = () => {
    const fileType = fileConstants.fileTypes.ddpcr;

    const ddpcrQuery = useFetchProcessed(fileType);

    const ddpcrData = ddpcrQuery?.isSuccess ? ddpcrQuery.data.data : null;


    const dataForTable = (ddpcrData) => ddpcrData?.map(item => {
        const properties = {

            "fileName": item.data_filename ? item.data_filename.split('\\\\').pop() : "No Filename",
            // API returns some of the values in fileInfo_datetime with leading space, so trim the leading whitespaces
            "runDate": item.fileinfo_datetime ? formatDate(item.fileinfo_datetime.trimStart()) : "",
            "projectName": item.project_name,
            "operator": item.generalinfo_user,
            "ingestDate": item.ingest_date ? formatDate(item.ingest_date) : "",
            "unit": item.serialnumber,
            "dbUUid": item.plate_uuid,
            "id": item.run_uuid

        };
        return properties;
    });

    const data = useMemo(() => {
        return dataForTable(ddpcrData);
    }, [ddpcrData]);

    const cols = [
        {
            field: 'fileName',
            headerName: 'File Name',
            description: 'Name of the File',
            renderCell: (params) => (
                <Link to={`/ddpcr/detail/${params.row.dbUUid}/${encodeURIComponent(params.row.fileName)}`}>{params.value}</Link>
            ),
            width: 600
        },
        {
            field: 'dbUUid',
            headerName: 'DB uuid',
            description: 'Plate UUID',
            width: 400
        },
        {
            field: 'ingestDate',
            headerName: 'Ingestion Date',
            description: 'Ingestion Date',
            width: 250
        },
        {
            field: 'unit',
            headerName: 'Unit',
            description: 'Serial Number',
            width: 250
        },

        {
            field: 'runDate',
            type: 'dateTime',
            headerName: 'Run Date',
            description: 'File Info Date Time',
            width: 250
        },
        {
            field: 'projectName',
            headerName: 'Project',
            description: 'Project Name',
            width: 400
        },
        {
            field: 'operator',
            headerName: 'Operator',
            description: 'General Info User',
            width: 400
        }

    ];

    return (
        <>


            {ddpcrData?.length > 0 ?
                <div className="oneToolContainer flex flex-col h-[80dvh]">
                    <h5 className="text-center pb-10 font-bold text-custom-green ">DDPCR Processed Data</h5>
                    <DataGrid columns={cols} rows={data} components={{
                        Toolbar: GridToolbar
                    }}>
                    </DataGrid>
                </div> : ddpcrQuery?.isFetching ?
                    <Spinner text="Fetching Data... Please wait" /> :
                    ddpcrQuery?.isLoadingError ? <p> Sorry could not load processed files...loading error </p> : "No processed files yet.."}

        </>
    )
}




export default ddPcrListProcessed;
